import {Command} from "../command";
import {CommandType} from "../commandType";
import {EstimateRowType} from "../state/estimateRowType";
import * as $ from "jquery";
import {EstimateTextRowPopupParams} from "../../components/estimate-text-row-popup/estimate-text-row-popup";
import {PopupType} from "../popups/popupType";
import {PopupMode} from "../popups/popup";
import {Application} from "../application";
import * as ko from "knockout";

export class EditEstimateTextRowCommand implements Command {
    constructor(private app: Application) {

    }

    type: CommandType = CommandType.EditEstimateTextRow;
    canExecute = ko.computed(() => {

        let estimate = this.app.state.estimate();

        if (!estimate)
            return false;

        if (estimate.selectedRow().length == 0 && !estimate.baseRow())
            return false;

        let row = estimate.selectedRow().length != 0 ? estimate.selectedRow()[0]: estimate.baseRow();

        if (!row)
            return false;

        return row.type == EstimateRowType.text;
    });
    canNotExecute = ko.computed(() => {
        return !this.canExecute();
    });
    execute(): JQueryPromise<any> {
        if (!this.canExecute())
            return $.Deferred().reject().promise();

        return this.app.popupsManager.show<EstimateTextRowPopupParams>(PopupType.estimateTextRow, false, <EstimateTextRowPopupParams> {
            popupMode: PopupMode.Edit,
        });
    }

    name = "Edit Text Row";
}


// WEBPACK FOOTER //
// ./ClientApp/services/commands/editEstimateTextRowCommand.ts